import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { EntityDetailsService } from 'app/entities/details/entity-details.service';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  templateUrl: './entity-details.component.html'
})

export class EntityDetailsComponent implements OnInit {
  entityIdDetails: EntityIdDetails;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private entityDetailsService: EntityDetailsService
  ) { }

  ngOnInit() {

    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();

    this.entityDetailsService.entityDetailsUpdated.subscribe(
      (entityDetails) => {
        this.entityIdDetails = entityDetails;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/details/entity-details.component.ts